import {
    DIRECTION_ASC,
    DIRECTION_DESC,
    NUMBERING_ENDS,
    NUMBERING_STARTS,
    SEQUENCE_ARABIC_EVEN,
    SEQUENCE_ARABIC_ODD,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import {
    getNextFromSequence,
    getPreviousFromSequence,
} from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/numberFromSequence';

function calculateCollectionLabel(
    {
        numbering,
        direction,
        sequence,
        numeral,
        prefix,
    },
    itemPosition,
    totalItems,
    enabledItems,
) {
    let label = null;
    let adjustedNumeral = numeral;

    if ([SEQUENCE_ARABIC_EVEN, SEQUENCE_ARABIC_ODD].includes(sequence)) {
        adjustedNumeral = Math.ceil(numeral/2);
    }
    if (numbering === NUMBERING_STARTS) {
        if (direction === DIRECTION_ASC) {
            label = getNextFromSequence(itemPosition + adjustedNumeral - 2, sequence);
        }
        if (direction === DIRECTION_DESC) {
            label = getPreviousFromSequence(totalItems - itemPosition + adjustedNumeral + 1, sequence);
        }
    }
    if (numbering === NUMBERING_ENDS) {
        if (direction === DIRECTION_ASC) {
            label = getPreviousFromSequence(enabledItems - itemPosition + adjustedNumeral + 1, sequence);
        }
        if (direction === DIRECTION_DESC) {
            label = getNextFromSequence(itemPosition + adjustedNumeral - 2, sequence);
        }
    }

    if (prefix) {
        label = `${prefix}${label}`;
    }

    return label;
}

export default calculateCollectionLabel;
